export default __webpack_public_path__ + "assets/363fe2ebf49f18a9d5f49beb942e5b39.png";